function controleVolumeVideo() {
  //botão para colocar mudo no vídeo (só para as páginas de cases internas);
  (function () {
    let video = $('[data-vid="video"]'),
      btn = $('[data-vid="som"]'),
      muted = video.get(0).muted;

    btn.click(function () {
      if (muted === false) {
        video.get(0).muted = true;
        muted = true;
        this.classList.remove('icon-sound');
        this.classList.add('icon-muted', 'active');
      } else if (muted === true) {
        video.get(0).muted = false;
        muted = false;
        this.classList.add('icon-sound');
        this.classList.remove('icon-muted', 'active');
      }
    });
  })();

  //função para ir para próxima seção (só para as páginas de cases internas)
  (function () {
    const btn = $('[data-vid="click-scroll"]'),
      section = $('[data-vid="target"]').offset().top - 90;
    btn.click(function (e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: section
      }, 900);
    });
  })();
}